import React from 'react';
import styled from '@emotion/native';
import { Image } from 'react-native';
import { green } from '../styles/colors';

interface CheckboxProps {
  checked: boolean;
  onPress: () => void;
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, onPress }) => {
  return (
    <Container onPress={onPress} checked={checked}>
      {checked && (
        <CheckmarkImage
          source={require('../../assets/images/CheckMarkWhite.png')}
          resizeMode="contain"
        />
      )}
    </Container>
  );
};

const Container = styled.TouchableOpacity<{ checked: boolean }>(
  ({ checked }) => ({
    width: 29,
    height: 29,
    borderWidth: 1,
    borderColor: green,
    backgroundColor: checked ? green : 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
  }),
);

const CheckmarkImage = styled(Image)({
  width: 24,
  height: 24,
  padding: 0,
});

export default Checkbox;
